/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
import React from 'react';

const IconCross = ({ classNames }) => {
  const classes = `icon ${classNames}`;
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className={classes}>
      <path d="M18.09 16.4l12.7-12.95a1.5 1.5 0 0 0-2.14-2.1L15.97 14.28 2.77 1.33a1.5 1.5 0 1 0-2.1 2.14L13.85 16.4.67 29.33a1.5 1.5 0 0 0 2.1 2.14l13.2-12.95 12.68 12.93a1.5 1.5 0 0 0 2.14-2.1L18.09 16.4z" />
    </svg>
  );
};

IconCross.defaultProps = {
  classNames: '',
};

IconCross.propTypes = {
  classNames: PropTypes.string,
};

export default IconCross;
